function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("title", null, "C6A816AA-CF6C-4FCD-9233-9613AA9BFB22");
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Lodge-enquiry",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "lodge-enq-lodged-LG",
  transform: "translate(-80.000000, -542.000000)",
  stroke: "#000000"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(64.000000, 224.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "ui/icon/utility/24/comms-circle",
  transform: "translate(16.000000, 318.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "circle",
  cx: 12,
  cy: 12,
  r: 11.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.50651558,5.5 C7.76246345,5.5 7.99989123,5.60143403 8.16217784,5.82035677 L8.16217784,5.82035677 L9.77608194,8.08567091 C9.94588214,8.33159773 10.0603399,8.52956531 10.0603399,8.7196156 C10.0603399,8.95435636 9.88781932,9.14332415 9.66264357,9.3680671 L9.66264357,9.3680671 L8.95504192,10.0951434 C9.12185087,11.3777246 9.90622367,12.3252776 10.7801896,13.2065999 C11.5673592,13.9836344 12.4177109,14.7030444 12.9029698,14.9618204 L12.9029698,14.9618204 L14.568206,14.3702451 C14.8130096,14.1246797 15.0144813,13.9205766 15.2640227,13.9205766 C15.4514882,13.9205766 15.6528617,14.0247959 15.8956797,14.2009411 L15.8956797,14.2009411 L18.2072546,15.833593 C18.4241774,15.9841546 18.5,16.2081939 18.5,16.4358395 C18.5,16.8311964 18.2911939,17.2242574 17.985465,17.5659005 C17.4042446,18.2132376 16.6734128,18.5 15.8430595,18.5 C13.7772781,18.5 11.2640062,16.8506542 9.19160117,14.7754209 C7.12148679,12.7174981 5.5,10.2411858 5.5,8.17354438 C5.5,7.35410354 5.76823758,6.61404131 6.39823932,6.01248908 C6.73738397,5.69223867 7.12109027,5.5 7.50651558,5.5 Z",
  id: "Path",
  fillRule: "nonzero"
})))));
const SvgUiIconUtility24CommsCircle = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUiIconUtility24CommsCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ui-icon-utility-24-comms-circle.abe3a497.svg";
export { ForwardRef as ReactComponent };